<template>
	
<div class="why">

	<div class="why-title">{{ section.summary.why.title }}</div>

	<div class="why-section" v-for="(segment, index) in section.summary.why.segments" :key="index">

		<div class="why-section-title">{{ segment.title }}</div>
		<div class="why-section-text" v-html="text(segment.text)"></div>

	</div>

</div>

</template>

<script>

export default {

	props: ['section'],

	data: function() {

		return {
			subsections: ['improve', 'chance', 'effects']
		}

	},

	computed: {

		why: function() {

			return this.$_.findWhere(this.$store.getters['data/aid/sections'], {
				id: 3
			})

		}

	},

	methods: {

		text: function(text) {

			return text.replace(/{{bullet}}/g, '<span class="bullet"></span>')

		}

	}
	
}

</script>

<style scoped>

.why {
	padding-bottom: 16px;
	border-bottom: 1px solid var(--aid-color);
	margin-bottom: 32px;
}

.is-pdf .why {
	margin-bottom: 0px;
	border-bottom: 0px;
}

.why-title {
	color: #343434;
	margin-bottom: 16px;
	font-size: 20px;
	text-transform: uppercase;
	font-weight: 600;
}

.is-pdf .why-title {
	font-size: 16px;
	margin-bottom: 10px;
}

.why-section {
	display: flex;
	padding: 16px 0px;
	flex-direction: row;
	border-bottom: 1px solid #ddd;
}

.is-pdf .why-section {
	border-bottom: 0px;
	padding: 0px 0px 10px 0px;
}

.why-section:last-child {
	border-bottom: 0px;
}

.why-section-title {
	color: #343434;
	font-weight: 600;
	font-size: 20px;
	width: 400px;
	flex-shrink: 0;
}

.is-pdf .why-section-title {
	font-size: 14px;
}

.why-section-text {
	flex-grow: 1;
	flex-basis: 0;
}

.why-section-text >>> p {
	font-size: 18px;
	line-height: 20px;
	font-weight: 300;
	color: #343434;
}

.is-pdf .why-section-text >>> p {
	font-size: 14px;
	line-height: 16px;
}

.why-section-text >>> .bullet {
	width: 22px;
	height: 22px;
	display: inline-block;
	vertical-align: middle;
	background-size: contain;
	background-position: 0% 0px;
	background-repeat: no-repeat;
	background-size: 16px 16px;
	background-image: url(~@/assets/aid/common/bullet.png);
}

.is-patient .why-section-text >>> .bullet {
	background-image: url(~@/assets/aid/common/link.png);
}

@media print {

	.why-section-text >>> .bullet:before {
		content: '-';
	}

}

</style>